export default __webpack_public_path__ + "static/media/70.a497be4f.png";